/**
 * Returns an array of numbers that are multiples of any of the given multiples.
 * @param {number} maxNum - The maximum number to search up to.
 * @param {number[]} multiples - An array of numbers to search for multiples of.
 * @returns {number[]} - An array of numbers that are multiples of any of the given multiples.
 */
export const getMultiples = (maxNum: number, multiples: number[]) => {
  const nums = []

  // Loop through all numbers from 1 up to the maximum number
  for (let i = 1; i <= maxNum; i++) {
    // Check if the current number is a multiple of any of the given multiples
    for (let j = 0; j < multiples.length; j++) {
      if (i % multiples[j] === 0 || j === 0) {
        nums.push(i) // Add the current number to the result array
        break // Stop checking for multiples of this number
      }
    }
  }

  return [...nums]
}
